export default "__VITE_PUBLIC_ASSET__455d824d__"